import { brandsApi, coreApi } from '@/api'

import { saveToRecentBrands } from '@/core'
import { convertToPathObject } from '@/utils/structure'

const singleBrandActions = {
  brand: {
    load: async ({ commit, dispatch }, brandId) => {
      const { brand, locations, theme, billingSettings } =
        await coreApi.getCoreDataByBrand(brandId)

      // Updates legacy brand system
      await dispatch('brand/setBrand', { brand, locations }, { root: true })
      await dispatch('locations/setAll', locations)

      commit('SET_BRANDS', [brand])
      commit('SET_BILLING_SETTINGS', billingSettings)
      commit('SET_THEME', theme)
    },
    setActive: async ({ dispatch, commit, getters, rootGetters }, brandId) => {
      if (brandId) {
        const brand = getters['brand/byId'](brandId)
        const locations = rootGetters['core/locations/byBrandId'](brandId)

        if (brand && locations) {
          await dispatch('brand/setBrand', { brand, locations }, { root: true })
        }

        if (brand) saveToRecentBrands(brand)
      }
      commit('SET_ACTIVE_BRAND', brandId)
    },
    unlinkGoogle: async ({ commit, getters }, brandId) => {
      const { success } = await brandsApi.unlinkGoogleAccount(brandId)

      const currentBrand = getters['brand/byId'](brandId)

      if (success) {
        commit('SET_BRAND', {
          ...currentBrand,
          integrations: {
            ...currentBrand.integrations,
            google: null,
          },
        })
      }
    },
    unload: async ({ commit }, brandId) => {
      commit('UNLOAD_BRAND', brandId)
    },
    update: {
      allLinks: async ({ commit }, { brandId, updatedLinks }) => {
        const { id, links } = await brandsApi.updateLinks(brandId, updatedLinks)

        commit('UPDATE_BRAND_LINKS', { id, update: links })
      },
      assets: async ({ commit }, { brandId, updatedAssets }) => {
        const { id, assets } = await brandsApi.updateBrandAssets(
          brandId,
          updatedAssets
        )

        commit('UPDATE_BRAND_ASSETS', { id, update: assets })
      },
      domain: async ({ commit }, { brandId, domain }) => {
        commit('SET_BRAND_DOMAIN', { brandId, domain })
      },
      link: async ({ commit, getters }, { brandId, update }) => {
        const targetLinks = getters['brand/links/*'](brandId)

        if (targetLinks) {
          const updatedLinks = { ...targetLinks, ...update }

          const { id, links } = await brandsApi.updateLinks(
            brandId,
            updatedLinks
          )

          commit('UPDATE_BRAND_LINKS', { id, update: links })
        }
      },
      name: async ({ commit }, { brandId, newName }) => {
        const { id, name } = await brandsApi.updateBrand(brandId, {
          name: newName,
        })

        commit('UPDATE_BRAND_NAME', { id, update: name })
      },
      priceRange: async ({ commit }, { brandId, newPriceRange }) => {
        const { id, priceRange } = await brandsApi.updateBrand(brandId, {
          priceRange: newPriceRange,
        })

        commit('UPDATE_BRAND_PRICE_RANGE', { id, update: priceRange })
      },
    },
  },
}

export default {
  ...convertToPathObject(singleBrandActions),
}
